<template>
  <div class="flex mx-n1 c-my-4">
    <a
      v-for="language in LanguagesFlags"
      :key="language.shortcut"
      :href="language.link"
      class="btn c-p-1 border-0 c-rounded-pill"
      aria-label="Select language"
    >
      <Component
        :is="language.svg"
        :class="
          language.shortcut === country
            ? 'icon border border-3 border-primary c-rounded-circle'
            : 'icon c-rounded-circle'
        "
        width="40"
        height="40"
      />
    </a>
  </div>
</template>

<script setup>
import { LanguagesFlags } from '@/components/svg/flags/languagesFlags'
import { useCountry } from '@/mixins/useCountry'

const country = useCountry()
</script>
